import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * User Service
 * Handles all user and member-related API calls
 */
const userService = {
  // Users
  getAllUsers: async () => {
    const response = await apiClient.post(API_ENDPOINTS.USER.GET_ALL);
    return response.data;
  },

  // Members
  getAllMembers: async () => {
    const response = await apiClient.post(API_ENDPOINTS.USER.GET_MEMBERS);
    return response.data;
  },

  // Membership
  getUserMembership: async (userId) => {
    const response = await apiClient.post(API_ENDPOINTS.USER.GET_MEMBERSHIP, { userId });
    return response.data;
  },
};

export default userService;

